export interface DialogSettings {
  isOpen?: boolean
  title: string
  image: string
  text: string
  type: 'error'
}

export type LoaderSize = 'small' | 'medium' | 'big' | 'tiny'

export enum Size {
  Big = 'big',
  Medium = 'medium',
  Small = 'small',
  Tiny = 'tiny',
}

export enum Variant {
  Error = 'error',
  Success = 'success',
}

export interface InfoMessage {
  isError: boolean
  title: string
}

export interface Dialogs {
  uploadPowerOfAttorney: {
    isOpen: boolean
  }
  lawsuitInstruction: {
    isOpen: boolean
  }
}

export enum NavigationItemStatus {
  Done = 'done',
  ToDo = 'todo',
  Draft = 'draft',
  Active = 'active',
}

export enum ActionVariant {
  Error = 'error',
  Required = 'required',
  Info = 'info',
  Success = 'success',
}
